import type { OfferApi } from '@fourthwall/services/dist/OffersApiClient'
import { OffersApiClient } from '@fourthwall/services/dist/OffersApiClient'
import type { Offer } from '@fourthwall/services/dist/models/offer'
import type { ApiError } from '@fourthwall/services/dist/types'
import { useMutation } from '@tanstack/react-query'

type MutationPayload = {
  offerId: string
  params: OfferApi.SetStatePayload
}
export const useStatusMutation = () => {
  const mutation = useMutation<Offer.Item, ApiError, MutationPayload>({
    mutationFn: async ({ offerId, params }) => {
      const { data } = await OffersApiClient.setState(offerId, params)

      return data
    },
  })

  return {
    status: mutation.data,
    statusMutation: mutation,
  }
}
